var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "plan-row",
    on: {
      "mouseenter": function mouseenter($event) {
        _vm.isHovered = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.isHovered = false;
      },
      "click": function click($event) {
        _vm.node.children && _vm.node.children.length ? _vm.isOpen = !_vm.isOpen : undefined;
      }
    }
  }, [_c('span', {
    staticClass: "plan-icon"
  }, [!_vm.node.id_pai ? _c('span', {
    staticClass: "plan-bullet"
  }, [_vm._v("●")]) : _c('span', {
    staticClass: "plan-connector"
  }, [_vm._v("└")])]), _c('div', {
    staticClass: "plan-name-col"
  }, [_c('span', {
    staticClass: "plan-name",
    class: {
      'is-root': !_vm.node.id_pai
    }
  }, [_vm._v(_vm._s(_vm.node.descricao))]), _vm.dreGrupoLabel ? _c('span', {
    staticClass: "plan-dre d-block"
  }, [_vm._v("DRE: " + _vm._s(_vm.dreGrupoLabel))]) : _vm._e()]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isHovered,
      expression: "isHovered"
    }],
    staticClass: "plan-actions"
  }, [!_vm.node.id_pai ? _c('span', {
    staticClass: "action-btn text-primary",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.addChild.apply(null, arguments);
      }
    }
  }, [_vm._v("+ Adicionar sub")]) : _vm._e(), _c('span', {
    staticClass: "action-btn text-primary",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.showModal.apply(null, arguments);
      }
    }
  }, [_vm._v("Editar")]), _c('span', {
    staticClass: "action-btn text-danger",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.deleteNode.apply(null, arguments);
      }
    }
  }, [_vm._v("Excluir")])])]), _c('b-collapse', {
    attrs: {
      "visible": _vm.isOpen
    }
  }, [_c('div', {
    staticClass: "children-container"
  }, _vm._l(_vm.node.children, function (child, index) {
    return _c('TreeNode', {
      key: child.id || index,
      attrs: {
        "node": child,
        "dreGrupos": _vm.dreGrupos
      },
      on: {
        "add-child": function addChild($event) {
          return _vm.$emit('add-child', $event);
        },
        "delete-node": function deleteNode($event) {
          return _vm.$emit('delete-node', $event);
        }
      }
    });
  }), 1)]), _c('b-modal', {
    attrs: {
      "title": "Editar Plano de Contas",
      "centered": "",
      "size": "lg"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          ref: "saveEdit",
          staticClass: "mr-2",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.saveEdit
          }
        }, [_vm._v("Salvar")]), _c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancelar")])], 1)];
      }
    }]),
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "50"
    },
    model: {
      value: _vm.editedName,
      callback: function callback($$v) {
        _vm.editedName = $$v;
      },
      expression: "editedName"
    }
  })], 1)], 1), _vm.node.id_pai ? _c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Grupo DRE:",
      "label-for": "edit-dre-grupo-select"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "edit-dre-grupo-select",
      "options": _vm.dreGruposOptions
    },
    model: {
      value: _vm.editedDreGrupo,
      callback: function callback($$v) {
        _vm.editedDreGrupo = $$v;
      },
      expression: "editedDreGrupo"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };